export default __webpack_public_path__ + "static/tooltip-interactive-1-dont-light-f357c35471727c124b8cad8825992d02f7e05706d25c771ea633ab054cc4c969.png";